import React, { useEffect, useState } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, InputNumber, message } from "antd";
import ModalCommon from "../../components/Modal";

const TEXT = {
    sencond: "Số giây mỗi lượt",
    numOfBall: "Số lượng của tất cả vật thể",
    speed: "Tốc độ rơi",
    bomRate: "Tỉ lệ (%) bom và dân theo VIP"
}

const SetupGameplay = () => {
    const [configGame, setConfigGame] = useState();
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

    const [vip0_5, setVip0_5] = useState();
    const [vip6_11, setVip6_11] = useState();
    const [vip12_15, setVip12_15] = useState();
    const [vip16_20, setVip16_20] = useState();

    const [turnDuration, setTurnDuration] = useState();
    const [totalSymbols, setTotaSymbols] = useState();
    const [fallSpeed, setFallSpeed] = useState();
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        getDataConfig();
    }, []);

    const getDataConfig = async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data.data;
            setConfigGame({
                turnDuration: data?.turnDuration,
                totalSymbols: data?.totalSymbols,
                fallSpeed: data?.fallSpeed,
                vip0_5: data?.vipLevels["VIP_0_5"],
                vip6_11: data?.vipLevels["VIP_6_11"],
                vip12_15: data?.vipLevels["VIP_12_15"],
                vip16_20: data?.vipLevels["VIP_16_20"]
            });

            setVip0_5(data?.vipLevels["VIP_0_5"]?.BOMB_RATE);
            setVip6_11(data?.vipLevels["VIP_6_11"]?.BOMB_RATE);
            setVip12_15(data?.vipLevels["VIP_12_15"]?.BOMB_RATE);
            setVip16_20(data?.vipLevels["VIP_16_20"]?.BOMB_RATE);
            setTurnDuration(data?.turnDuration);
            setTotaSymbols(data?.totalSymbols);
            setFallSpeed(data?.fallSpeed);
        } catch (err) {
            console.log(err);
        }
    };

    const handleChangeInput = (e, key) => {
        switch (key) {
            case 1: setTurnDuration(e); return;
            case 2: setTotaSymbols(e); return;
            case 3: setFallSpeed(e); return;
            case 4: setVip0_5(e/100); return;
            case 5: setVip6_11(e/100); return;
            case 6: setVip12_15(e/100); return;
            case 7: setVip16_20(e/100); return;
            default: return;
        }
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);
            if (
                !validNumber(turnDuration) || !validNumber(totalSymbols) || !validNumber(fallSpeed)
            ) {
                showError("Vui lòng nhập số hợp lệ");
                return;
            }
            setIsShowModalSuccess(true);
            const body = {
                config: {
                    turnDuration: turnDuration ? turnDuration : configGame?.turnDuration,
                    totalSymbols: totalSymbols ? totalSymbols : configGame?.totalSymbols,
                    fallSpeed: fallSpeed? fallSpeed : configGame?.fallSpeed,
                    vipLevels: {
                        VIP_0_5: vip0_5 ? 
                            { MAX_SCORE: configGame?.vip0_5.MAX_SCORE, BOMB_RATE: vip0_5, PERSON_RATE: vip0_5 } : 
                            configGame?.vip0_5,
                        VIP_6_11: vip6_11 ? 
                            { MAX_SCORE: configGame?.vip6_11.MAX_SCORE, BOMB_RATE: vip6_11, PERSON_RATE: vip6_11 } : 
                            configGame?.vip6_11,
                        VIP_12_15: vip12_15 ? 
                            { MAX_SCORE: configGame?.vip12_15.MAX_SCORE, BOMB_RATE: vip12_15, PERSON_RATE: vip12_15 } : 
                            configGame?.vip12_15,
                        VIP_16_20: vip16_20 ? 
                            { MAX_SCORE: configGame?.vip16_20.MAX_SCORE, BOMB_RATE: vip16_20, PERSON_RATE: vip16_20 } : 
                            configGame?.vip16_20,
                    }
                }
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
        } catch (err) {
            console.log(err);
        }
    };

    const validNumber = (value) => {
        if (value === undefined || value === null || value === "") {
            return false;
        }
        const number = parseInt(value);
        return !isNaN(number) && number > 0;
    }

    const showError = (errorMessage) => {
        messageApi.open({
        type: 'error',
        content: errorMessage,
        });
    };


    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const renderInputNumer = (key, defaultValue, changeInput, max, label) => {
        return (
            <div className={`flex w-full items-center ${key !== "vip0_5" ? "mt-4" : ""}`}>
                <div className="flex w-[30%] justify-end mr-10">{label}:</div>
                <div className="w-[50%]">
                    <InputNumber
                        key={key}
                        style={{ width: "100%" }}
                        defaultValue={defaultValue}
                        onChange={changeInput}
                        max={max}
                        min={1}
                    />
                </div>
            </div>
        )
    }

    return (
        <div className="col-12">
            {contextHolder}
            {configGame && 
                <div className="col-12">
                    <div className="flex w-full">
                        <div className="flex flex-col w-full items-center justify-center">
                            <div className="col-10 mt-2 flex flex-col items-center justify-center">
                                {configGame && renderInputNumer(
                                    "vip0_5",
                                    (configGame?.vip0_5?.BOMB_RATE * 100), 
                                    (e) => handleChangeInput(e, 4), 
                                    100, `${TEXT.bomRate} 0 - 5`,
                                )}

                                {configGame && renderInputNumer(
                                    "vip6_11",
                                    (configGame?.vip6_11?.BOMB_RATE * 100), 
                                    (e) => handleChangeInput(e, 5), 
                                    100, `${TEXT.bomRate} 6 - 11`,
                                )}

                                {configGame && renderInputNumer(
                                    "vip12_15",
                                    (configGame?.vip12_15?.BOMB_RATE * 100), 
                                    (e) => handleChangeInput(e, 6), 
                                    100, `${TEXT.bomRate} 12 - 15`,
                                )}

                                {configGame && renderInputNumer(
                                    "vip16_20",
                                    (configGame?.vip16_20?.BOMB_RATE * 100), 
                                    (e) => handleChangeInput(e, 7), 
                                    100, `${TEXT.bomRate} 16 - 20`,
                                )}

                                {configGame && renderInputNumer(
                                    "turnDuration",
                                    configGame?.turnDuration, 
                                    (e) => handleChangeInput(e, 1), 
                                    500, `${TEXT.sencond}`
                                )}

                                {renderInputNumer(
                                    "totalSymbols",
                                    configGame?.totalSymbols, 
                                    (e) => handleChangeInput(e, 2), 
                                    500, `${TEXT.numOfBall}`
                                )}

                                {renderInputNumer(
                                    "fallSpeed",
                                    configGame?.fallSpeed, 
                                    (e) => handleChangeInput(e, 3), 
                                    50000, `${TEXT.speed}`
                                )}
                            </div>
                            <div className="col-10 mt-5 flex items-center justify-center">
                                <Button type="primary" onClick={handleShowModal}>
                                    Cập nhật
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                    }}
                />
            )}
        </div>
    );
};

export default SetupGameplay;
